import "./spacer.css";
import { SpacerProps } from "./spacer.props";

const Spacer: React.FC<SpacerProps> = (props) => {
  return (
    <div className={`spacer-wrapper ${props.className}`}>{props.children ?? <></>}</div>
  );
};

export default Spacer;
